import moment from 'moment';

export function isBeforeTodayCheckoutRequestCutoff(dateValue, nowValue = moment(), cutoffHour = 17) {
  const now = moment(nowValue);
  const day = moment(dateValue);

  if (!now.isValid() || !day.isValid()) {
    return false;
  }

  const todayStart = now.clone().startOf('day');
  const cutoff = todayStart.clone().hour(cutoffHour).minute(0).second(0).millisecond(0);

  return day.isSame(todayStart, 'day') && now.isBefore(cutoff);
}
